import types from "~/store/toast/toastTypes";

export default {
  showSuccessToast: msg => ({ type: types.TOAST_SHOW_SUCCESS, msg }),
  showErrorToast: msg => ({ type: types.TOAST_SHOW_ERROR, msg })
};
